import React, {useContext, useEffect, useState} from 'react';
import {FormattedMessage} from "react-intl";

// Components
import PageTitle from "components/WMS/Mobile/PageTitle";
import WmsMobileLayout from "../wmsMobileLayout";
import {ReactComponent as MenuIcon} from "assets/img/wms/more.svg"

// Local Components
import ShippingMethodDrawer from "./components/ShippingMethodDrawer";
import ShippingMethodItem from "./components/ShippingMethodItem";

// Context
import {WMSContext} from "../context/WMSContext";

// Utils
import {ShipmentStatus} from "utils/ShipmentStatus";

// API
import {wmsShipmentForShipping} from 'api/shipment/list';
import {Grid} from "@mui/material";
import CustomButton from "../../../components/CustomButton";
import ExpeditionListViewDrawer from "./components/ExpeditionListViewDrawer";
import ShippingActionDrawer from "./components/ShippingActionDrawer";
import {grey300, red500} from "../../../assets/jss/main";
import PrinterConfigurationDrawer
    from "../packing/components/PackingOrderList/components/Drawers/PrinterConfigurationDrawer";

function Shipping(props) {
    const [shippingMethods, setShippingMethods] = useState([]);
    const [selectedShippingMethod, setSelectedShippingMethod] = useState(null);
    const [openExpeditionListView, setOpenExpeditionListView] = useState(false)
    const [openActionDrawer, setOpenActionDrawer] = useState(false)
    const [openPrinterConfigurationDrawer, setOpenPrinterConfigurationDrawer] = useState(false)

    const {currentInventory, currentOrganization, preferredPrinter, isMobile} = useContext(WMSContext);

    useEffect(() => {
        if (!currentInventory) {
            return;
        }

        getShipments();
    }, [currentInventory]);

    function getShipments() {
        if (!currentInventory) {
            return;
        }

        wmsShipmentForShipping(currentInventory.id).then((res) => {
            let tempShipment = res["hydra:member"]

            tempShipment = tempShipment.filter(shipment => currentInventory.id !== shipment.shippingMethod.destinationInventory)

            setShippingMethods(groupByShippingMethod(tempShipment));
            setSelectedShippingMethod(null)
        })
    }

    const handleClosePrinterConfigurationDrawer = () => {
        setOpenPrinterConfigurationDrawer(false)
        window.location.reload()
    }

    function groupByShippingMethod(shipments) {
        const groupedShipments = {};

        shipments.forEach(shipment => {
            if (!shipment.container || !shipment.shippingMethod) {
                return;
            }

            const shippingMethod = shipment.shippingMethod;
            const shippingMethodId = shippingMethod.id;
            const containerId = shipment.container.id;

            if (!groupedShipments[shippingMethodId]) {
                groupedShipments[shippingMethodId] = {
                    'shippingMethod': shippingMethod,
                    'containers': {},
                    'shipmentCount': 0,
                };
            }

            groupedShipments[shippingMethodId]['shipmentCount'] += 1;

            if (!groupedShipments[shippingMethodId].containers[containerId]) {
                groupedShipments[shippingMethodId].containers[containerId] = {
                    'container': shipment.container,
                    'shipments': [],
                    'shipmentCount': 0,
                };
            }

            groupedShipments[shippingMethodId].containers[containerId].shipments.push(shipment);
            groupedShipments[shippingMethodId].containers[containerId].shipmentCount += 1;
        });

        // converti les containers en tableau pour chaque shipping method
        for (const entry of Object.values(groupedShipments)) {
            entry.containers = Object.values(entry.containers);
        }

        return groupedShipments;
    }

    useEffect(() => {
        if (openExpeditionListView || openPrinterConfigurationDrawer) {
            setOpenActionDrawer(false)
        }
    }, [openPrinterConfigurationDrawer, openExpeditionListView]);

    return (
        <WmsMobileLayout className="wms-test-component">
            <WmsMobileLayout.LeftHeader>
            </WmsMobileLayout.LeftHeader>
            <WmsMobileLayout.RightHeader>
            </WmsMobileLayout.RightHeader>
            <WmsMobileLayout.Content>
                <Grid container justifyContent={"space-between"} alignItems={"center"} paddingRight={"16px"} flexWrap={'nowrap'}>
                    <PageTitle
                        title={<FormattedMessage id='wms.shipping.title' />}
                        subtitle={<FormattedMessage id='wms.shipping.subtitle' />}
                    />


                        {currentOrganization && currentOrganization.printExpeditionList && (
                            <Grid
                                container
                                flexWrap={'nowrap'}
                                sx={{width: "fit-content"}}
                                gap={"8px"}
                            >
                                {!preferredPrinter?.documentPrinterId && (
                                    <Grid container direction={isMobile ? "column" : "row"}>
                                        <span style={{margin: "8px", color: red500, width: "fit-content"}}><FormattedMessage id={"wms.packing.noPrinter.short"}/></span>
                                        <CustomButton color={"red"} variant={'outlined'} onClick={() => setOpenPrinterConfigurationDrawer(true)} rounded><FormattedMessage id={"wms.packing.noPrinter.buttonLabel"}/></CustomButton>
                                    </Grid>
                                )}

                                <CustomButton
                                    onClick={() => setOpenActionDrawer(true)}
                                    variant={"outlined"}
                                    color={"default"}
                                >
                                    <MenuIcon />
                                </CustomButton>
                            </Grid>
                        )}

                    {currentOrganization && !currentOrganization.printExpeditionList && (
                        <CustomButton onClick={() => setOpenExpeditionListView(true)}>
                            <FormattedMessage id={"wms.shipping.show_expeditions_lists"}/>
                        </CustomButton>
                    )}

                </Grid>

                {openPrinterConfigurationDrawer && (
                    <PrinterConfigurationDrawer
                        open={openPrinterConfigurationDrawer}
                        onClose={() => handleClosePrinterConfigurationDrawer()}
                    />
                )}

                {openExpeditionListView && (
                    <ExpeditionListViewDrawer
                        open={openExpeditionListView}
                        handleClose={() => setOpenExpeditionListView(false)}
                    />
                )}

                {openActionDrawer && (
                    <ShippingActionDrawer
                        open={openActionDrawer}
                        handleClose={() => setOpenActionDrawer(false)}
                        openPrinterConfigurationDrawer={() => setOpenPrinterConfigurationDrawer(true)}
                        openExpeditionListDrawer={() => setOpenExpeditionListView(true)}
                    />
                )}

                {shippingMethods && Object.entries(shippingMethods).map(([shippingMethodId, entry], index) => (
                    <ShippingMethodItem
                        key={shippingMethodId}
                        name={entry.shippingMethod.name}
                        discr={entry.shippingMethod.discr}
                        shipmentCount={entry.shipmentCount}
                        onClick={() => {
                            if (!currentOrganization?.printExpeditionList || preferredPrinter?.documentPrinterId) {
                                setSelectedShippingMethod({...entry})
                            }
                        }}
                    />
                ))}
                <ShippingMethodDrawer
                    shippingMethod={selectedShippingMethod}
                    open={!!selectedShippingMethod}
                    handleClose={() => setSelectedShippingMethod(null)}
                    refreshShippingMethods={getShipments}
                />
            </WmsMobileLayout.Content>
        </WmsMobileLayout>
    );
}

export default Shipping;
